import { useState, useEffect, FunctionComponent, } from 'react';
import { Button, Input, Switch, Typography} from '../../tailwindcomponents';
import { Dictionary } from '../../components';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducer';
import WarrantyApi from '../../api/warranty';
import { dictionary } from '../../types/general';

type HourlyRateProps = {
  refreshHourlyRates: Function,
}

// Basic dictionary page using the dictionary component so easy to change style of all dictionary pages if needed.
const EditHourlyRate: FunctionComponent<HourlyRateProps> = ({ refreshHourlyRates }) => {
  const [hourlyRates, setHourlyRates] = useState(Array<dictionary>());
  const [newHourlyRate, setNewHourlyRate] = useState('');
  const store = useSelector((state: RootState) => state);
  const currentUser = store.user.me;
  const [showActive, setShowActive] = useState(true);

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refresh = () => {
    WarrantyApi.getAllHourlyRates().then(res => {
      setHourlyRates(res.data);
      refreshHourlyRates();
    });
  }

  const addHourlyRate = () => {
    let tempHourlyRate = newHourlyRate.replace(',', '.')
    WarrantyApi.addHourlyRate(tempHourlyRate, currentUser.user_id).then(res => {
      refresh();
      setNewHourlyRate('');
    });
  }

  return (
    <div>
      <div className="flex flex-wrap w-full items-start justify-center">
        <div className="w-1/2">
          <div className="flex flex-wrap w-full">
            <div className="w-1/3 lg:w-7/12"></div>
            <div className="w-1/3 lg:w-1/12">
              <Typography text="Current" variant="subtitle2" color="textPrimary" margin={[1, 0, 0, 0]} />
            </div>
            <div className="w-1/6 lg:w-1/12">
              <Switch
                checked={!showActive}
                onChange={() => setShowActive(!showActive)}
                color="secondary"
                name="checkedB"
              />
            </div>
            <div className="w-1/6 lg:w-1/12">
              <Typography text="History" variant="subtitle2" color="textPrimary" margin={[1, 0, 0, 0]} />
            </div>
          </div>
          <div className="w-5/6">
            {
              hourlyRates !== undefined && hourlyRates.filter(type => type.visible === showActive).map(row => (
                <Dictionary deleteButton={false} name={row.name} object={row} deleted={showActive === true ? false : true} description={row.description} id={row.id} deleteProperty={(row: dictionary) => { }}></Dictionary>
              ))
            }
          </div>
        </div>
        <div className="flex flex-wrap w-5/12">
          <div className="w-full">
            <br />
            <Input
              multiline={false}
              label_text="Hourly Rate"
              help_text="Please type in updated hourly rate"
              type="text"
              value={newHourlyRate}
              width={50}
              onTextChange={(value: string) => setNewHourlyRate(value)}
            />
          </div>
          <br />
          <Button variant="contained" color="primary" className="bg-accent text-white text-sm" onClick={() => addHourlyRate()} >
            Add Property
          </Button>
        </div>
      </div>
    </div>
  );
};
export default EditHourlyRate;
